/**
 * Liste des images d'une page auditée (preview + statut alt).
 */

/** Toutes les images connues pour une page (audit récent avec images_list). */
export function resolveImagesList(seo) {
  const am = seo?.advanced_metrics || {};
  if (Array.isArray(am.images_list) && am.images_list.length > 0) {
    return am.images_list.map((img) => ({
      src: img.src || '',
      alt: img.alt || '',
      has_alt: img.has_alt ?? !!(img.alt && String(img.alt).trim()),
    }));
  }
  const without = am.images_without_alt_list || [];
  if (without.length > 0) {
    return without.map((img) => ({
      src: img.src || '',
      alt: '',
      has_alt: false,
    }));
  }
  return [];
}
